import CandidatesInBankOfTalentsList from './CandidatesInBankOfTalentsList';

export default CandidatesInBankOfTalentsList;
